import baseLogger, { CONTEXTS } from 'widget/logger';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { ArtistData } from 'widget/ArtistRadio/types';
import { TransportInterface } from 'widget/utils/transport/types';

/*
 * Fetch artist data given a artist id
 */
export async function fetchArtist({
  ampUrl = '',
  logger = baseLogger,
  artistId,
  transport,
}: {
  ampUrl?: string;
  logger?: Logger;
  artistId: number;
  transport: TransportInterface;
}) {
  if (!artistId) {
    const errObj = new HttpError(
      400,
      'Failed to fetch artist station info, artistId missing.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  const [url, requestName] = createTaggedUrl`${{
    ampUrl,
  }}/api/v3/artists/profiles/${{
    artistId: String(artistId),
  }}`;

  const response = await transport.get(url, { params: { requestName } });
  const { data } = response as { data?: ArtistData };

  if (!data?.artist) {
    const errObj = new HttpError(
      400,
      'Failed to fetch artist station info, no results.',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  return data;
}
